import { Component, Input } from "@angular/core";
import { User, PanelMember, Discussion } from "../../../../models";

@Component({
  selector: "del-panelSeat-button",
  templateUrl: "./del-panelSeat-button.component.html",
  styleUrls: [
    "./del-panelSeat-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class DelPanelSeatButtonComponent {
  @Input() currentUser: User;
  @Input() discussion: Discussion;
  @Input() currentPanelMember: PanelMember;
  @Input() canModifyDiscussion: boolean;
  constructor() {}
  ngOnInit() {}
}
